/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_TitleInputs */

const en_mk_model_title = /** @type {(inputs: Mk_Model_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The skill picks the model, so you don't have to guess`)
};

const id_mk_model_title = /** @type {(inputs: Mk_Model_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill yang memilih model, bukan kamu yang menebak`)
};

/**
* | output |
* | --- |
* | "The skill picks the model, so you don't have to guess" |
*
* @param {Mk_Model_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_title = /** @type {((inputs?: Mk_Model_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_title(inputs)
	return en_mk_model_title(inputs)
});